export const requiredStatusForDigitalPan = ["GENERATE", "DONE", "CANCELLED"];
